module.exports = __webpack_public_path__ + "img/07.9e45420c.jpg";